import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { IResourceAuthorization } from '@verzekeringapp-mono/shared/src/models/resource_authorization'

interface IProps {
  resourceAuthorization: IResourceAuthorization
  current?: boolean
  onPressSelect?: (resourceAuthorization: IResourceAuthorization) => void
  onPressDelete?: (resourceAuthorization: IResourceAuthorization) => void
  isNew?: boolean
}

const getCardStyle = ({
  isActive,
  isCurrentActive,
  isNew
}: {
  isActive: boolean
  isCurrentActive: boolean
  isNew?: boolean
}) => {
  if (!isActive) {
    return 'border-border-default bg-surface-info opacity-50'
  }

  if (isCurrentActive) {
    return 'border-status-success-strong bg-status-success-subtle'
  }

  if (isNew) {
    return 'border-border-brand bg-surface-brand-subtle'
  }

  return 'border-border-default bg-surface-card'
}

const getIconSurfaceStyle = ({
  isActive,
  isCurrentActive,
  isNew
}: {
  isActive: boolean
  isCurrentActive: boolean
  isNew?: boolean
}) => {
  if (isCurrentActive) {
    return 'bg-status-success-strong'
  }

  if (isNew) {
    return 'bg-surface-card'
  }

  if (isActive) {
    return 'bg-surface-info'
  }

  return 'bg-surface-card'
}

const CombilPolicyListItem: React.FC<IProps> = ({
  resourceAuthorization,
  current,
  onPressSelect,
  onPressDelete,
  isNew
}) => {
  const isActive = resourceAuthorization.active
  const isCurrentActive = !!current && isActive
  const cardStyle = getCardStyle({ isActive, isCurrentActive, isNew })
  const iconSurfaceStyle = getIconSurfaceStyle({ isActive, isCurrentActive, isNew })
  const userIconStyle = isCurrentActive ? 'text-status-success-on-strong' : 'text-icon-secondary'
  const newBadgeStyle = isCurrentActive ? 'text-status-success-on-strong' : 'text-icon-brand'

  return (
    <div
      className={`flex flex-1 flex-row items-center justify-between gap-1 rounded-lg border p-4 ${cardStyle}`}
    >
      <button
        className='flex flex-1 items-center gap-1 text-text-primary disabled:cursor-not-allowed'
        onClick={() => onPressSelect?.(resourceAuthorization)}
        type='button'
        disabled={!isActive}
      >
        <div className={`mr-2 flex h-[34px] w-[34px] aspect-square items-center justify-center rounded-full ${iconSurfaceStyle}`}>
          {isNew && !onPressDelete && isActive && (
            <div className='relative h-0 w-0'>
              <FontAwesomeIcon
                icon='stars'
                className={`absolute bottom-0 right-0 ${newBadgeStyle}`}
              />
            </div>
          )}

          <FontAwesomeIcon
            icon={isActive ? 'user' : 'user-slash'}
            size='sm'
            className={userIconStyle}
          />
        </div>

        <div className='flex flex-col items-start text-start'>
          <p>{resourceAuthorization.name}</p>

          <p className='text-sm light'>{`Combipolisnummer: ${resourceAuthorization.combiNumber}`}</p>
        </div>
      </button>

      {isCurrentActive && (
        <FontAwesomeIcon
          icon='check-circle'
          size='sm'
          className='text-status-success-strong'
        />
      )}

      {!current && onPressDelete && isActive && (
        <button
          type='button'
          onClick={() => onPressDelete?.(resourceAuthorization)}
        >
          <FontAwesomeIcon
            icon='trash'
            size='sm'
            className='text-icon-secondary'
          />
        </button>
      )}
    </div>
  )
}

export default CombilPolicyListItem
